export const updatedAt = {
  key: 'updated_at',
  label: '最終更新日時',
} as const;

export const brand = {
  key: 'brand',
  label: 'ブランド選択',
} as const;

export const memo = {
  key: 'memo',
  label: '社内メモ',
};
